import { useState } from 'react'
import styled from 'styled-components'
import theme from '~/design'
import categories from '~/packages/categories'
import sectors, { getSectorsForDomain } from '~/packages/sectors'
import { ButtonVariants } from '~/components/buttonVariants'
import { WrapperButtons } from '../../styles/modals'
import { CategoryListToggle } from './categoryListToggle'

const Wrapper = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    height: 100%;
    width: 100%;
  }

  h4 {
    display: none;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: flex;
      font-weight: bold;
      color: #363636;
      font-size: 1rem;
      user-select: none;
      margin: 1.5rem 0 0 1rem;
    }
  }

  .menu {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${({ theme }) => theme.colors.lightGrey};
    padding: ${({ theme }) => theme.padding(1)} ${({ theme }) => theme.padding(2)};
    height: fit-content;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      width: 100%;
      height: fit-content;
      border-right: none;
      box-shadow: none;
      overflow-y: auto;
    }

    .header {
      display: none;
      @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
        font-weight: 600;
        font-size: 1rem;
        color: ${theme.colors.darkGrey};
        user-select: none;
        margin: 10px 0 0;
        display: block;
      }
    }
  }
`

const WrapperButtonsFilter = styled(WrapperButtons)`
  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: none;
  }
`

interface CategoryFilterProps {
  currentCategory: typeof categories
  handleClick: (info: { key: string; title: string; sectorKey: string }) => void
  categoriesInfo: {
    key: string
    title: string
    sectorKey: string
  }[]
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>
  isMobile: boolean
}

const CategoryFilter = ({
  categoriesInfo,
  currentCategory,
  handleClick,
  setIsFilterOpen,
  isMobile,
}: CategoryFilterProps) => {
  const [selectedCategory, setSelectedCategory] = useState<typeof categories>(currentCategory)

  const handleSelectCategory = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    info: { key: string; title: string; sectorKey: string },
  ) => {
    event.preventDefault()
    event.stopPropagation()
    const newSelectedCategory = {
      [info.key]: {
        title: info.title,
        sectorKey: info.sectorKey,
      },
    }
    setSelectedCategory(newSelectedCategory)
    if (!isMobile) confirmCategory(event, newSelectedCategory)
  }

  const confirmCategory = (
    event: React.MouseEvent<Element, MouseEvent>,
    selectedCategory: typeof categories,
  ) => {
    event.preventDefault()
    handleClick({
      key: Object.keys(selectedCategory)[0],
      title: selectedCategory[Object.keys(selectedCategory)[0]].title,
      sectorKey: selectedCategory[Object.keys(selectedCategory)[0]].sectorKey,
    })
    setIsFilterOpen(false)
  }

  const sectorsFilter = getSectorsForDomain(location.hostname)

  return (
    <Wrapper>
      <div className='menu'>
        <p className='header'>Filtrar por</p>
        {Object.entries(sectors).map(([key, value]) =>
          !sectorsFilter || sectorsFilter.includes(key) ? (
            <CategoryListToggle
              key={key}
              categoryKey={key}
              categoryName={value.title}
              selectedCategory={selectedCategory}
              categoriesInfo={categoriesInfo}
              handleSelectCategory={handleSelectCategory}
            />
          ) : null,
        )}
      </div>
      <WrapperButtonsFilter>
        <ButtonVariants
          onClick={() => setIsFilterOpen(false)}
          label='Voltar'
          variant='transparent'
          size='sm'
          style={{ height: '30px' }}
        />

        <ButtonVariants
          onClick={(event: React.MouseEvent<Element, MouseEvent>) =>
            confirmCategory(event, selectedCategory)
          }
          variant='primary'
          label='Filtrar'
          size='sm'
          style={{ height: '30px' }}
        />
      </WrapperButtonsFilter>
    </Wrapper>
  )
}

export default CategoryFilter
